module.exports = __webpack_public_path__ + "img/head.885d8962.png";